import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MessageErrorResolver } from "../../utilities/message-error-resolver";
import { catchError, EMPTY, map, Observable, tap } from "rxjs";
import { IPage } from "../../models/pagination/page";
import { ResponseDto, ResponseWithErrorDto } from "../../models/exceptions/response-dto";
import { ICompetitionDto } from "../../models/competition-dto";
import { ICompetitionBlockDto } from '../../models/competition-block-dto';
import { LoadingService } from './loading.service';

export interface BlocoCompeticaoInscrito {
  incNrId: number;
  bloNrId: number;
  incTxResumo: string;
  bloDtFimInscricao: string;
  bloDtInicioInscricao: string;
  bloDtFimSubFichaInscricao: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompetitionBlockService {
  private url: string = environment.apiUrl + "/v1/blocos-competicoes";

  constructor(private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService) {
  }

  public getAllCompetitionByBlocks(bloNrId: number, page?: number, size?: number, acontecendoHoje?: boolean, aconteceraNoFuturo?: boolean, comTxNome?: string): Observable<IPage<ICompetitionDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    if (aconteceraNoFuturo) params = params.set("aconteceraNoFuturo", aconteceraNoFuturo);
    if (acontecendoHoje) params = params.set("acontecendoHoje", acontecendoHoje);
    if (comTxNome) params = params.set("comTxNome", comTxNome);
    return this.httpClient.get<ResponseDto<IPage<ICompetitionDto>>>(environment.apiUrl + `/v2/blocos-competicoes/${bloNrId}/competicoes`, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public getAllBlocoCompByEventId(eveNrId: number, page?: number, size?: number): Observable<IPage<ICompetitionBlockDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    return this.httpClient.get<ResponseDto<IPage<ICompetitionBlockDto>>>(this.url + `/${eveNrId}/blocoCompeticoes`, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  buscarBlocoPorInscricao(incNrId: number): Observable<ResponseDto<BlocoCompeticaoInscrito>> {
    const url = `${this.url}/${incNrId}/inscricao`;
    return this.httpClient.get<ResponseDto<BlocoCompeticaoInscrito>>(url);
  }
  
  buscarBlocoPorId(bloNrId: number): Observable<ResponseDto<ICompetitionBlockDto>> {
    const url = `${this.url}/${bloNrId}`;
    return this.httpClient.get<ResponseDto<ICompetitionBlockDto>>(url);
  }
}
